module.exports = __webpack_public_path__ + "media/86_Long.5f80fdfe.mp3";